import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const BODY_TYPES = ["Hatchback", "Sedan", "SUV", "MUV", "Luxury"];
const FUELS = ["Petrol", "Diesel", "CNG", "Electric", "Hybrid"];
const TRANSMISSIONS = ["Manual", "Automatic"];
const OWNERS = [1, 2, 3];

const chipCls = (active) => `cs-chip ${active ? "!border-[#940C2C] !bg-[#F6E6EB] !text-[#940C2C] !font-bold" : ""}`;
export const FilterSidebar = ({ value, onChange, onClear }) => {
  const [makes, setMakes] = useState([]);
  useEffect(() => {
    api.get("/vehicles/facets").then((r) => setMakes(r.data.makes || [])).catch(() => {});
  }, []);

  const set = (k, v) => onChange({ ...value, [k]: v });
  const toggle = (k, v) => set(k, value[k] === v ? undefined : v);

  return (
    <div className="space-y-6" data-testid="filter-sidebar">
      <div className="flex items-center justify-between">
        <h3 className="font-display font-bold text-base text-gray-900">Filters</h3>
        <button onClick={onClear} className="text-xs text-[#940C2C] font-semibold" data-testid="filter-clear-btn">Clear all</button>
      </div>

      <Section title="Price (₹)">
        <div className="grid grid-cols-2 gap-2">
          <input type="number" placeholder="Min" value={value.price_min || ""} onChange={(e) => set("price_min", e.target.value || undefined)} className="rounded-md border border-gray-200 px-3 py-2 text-sm" data-testid="filter-price-min" />
          <input type="number" placeholder="Max" value={value.price_max || ""} onChange={(e) => set("price_max", e.target.value || undefined)} className="rounded-md border border-gray-200 px-3 py-2 text-sm" data-testid="filter-price-max" />
        </div>
        <div className="flex flex-wrap gap-1.5 mt-2">
          {[["Under 5L", 0, 500000], ["5–10L", 500000, 1000000], ["10–20L", 1000000, 2000000], ["20L+", 2000000, null]].map(([l, mn, mx]) => (
            <button key={l} onClick={() => onChange({ ...value, price_min: mn || undefined, price_max: mx || undefined })} className="cs-chip">{l}</button>
          ))}
        </div>
      </Section>

      <Section title="Make">
        <div className="flex flex-wrap gap-1.5">
          {makes.map((m) => (
            <button key={m} onClick={() => toggle("make", m)} className={chipCls(value.make === m)} data-testid={`filter-make-${m}`}>{m}</button>
          ))}
        </div>
      </Section>

      <Section title="Body Type">
        <div className="flex flex-wrap gap-1.5">
          {BODY_TYPES.map((b) => (
            <button key={b} onClick={() => toggle("body_type", b)} className={chipCls(value.body_type === b)} data-testid={`filter-body-${b}`}>{b}</button>
          ))}
        </div>
      </Section>

      <Section title="Fuel">
        <div className="flex flex-wrap gap-1.5">
          {FUELS.map((f) => (
            <button key={f} onClick={() => toggle("fuel", f)} className={chipCls(value.fuel === f)} data-testid={`filter-fuel-${f}`}>{f}</button>
          ))}
        </div>
      </Section>

      <Section title="Transmission">
        <div className="flex flex-wrap gap-1.5">
          {TRANSMISSIONS.map((t) => (
            <button key={t} onClick={() => toggle("transmission", t)} className={chipCls(value.transmission === t)}>{t}</button>
          ))}
        </div>
      </Section>

      <Section title="Year (From)">
        <input type="number" placeholder="e.g. 2018" value={value.year_min || ""} onChange={(e) => set("year_min", e.target.value || undefined)} className="w-full rounded-md border border-gray-200 px-3 py-2 text-sm" />
      </Section>

      <Section title="Max KM Driven">
        <div className="flex flex-wrap gap-1.5">
          {[25000, 50000, 75000, 100000].map((k) => (
            <button key={k} onClick={() => toggle("km_max", k)} className={chipCls(value.km_max === k)}>{k.toLocaleString("en-IN")} km</button>
          ))}
        </div>
      </Section>

      <Section title="Owners (Max)">
        <div className="flex flex-wrap gap-1.5">
          {OWNERS.map((o) => (
            <button key={o} onClick={() => toggle("owners", o)} className={chipCls(value.owners === o)}>Up to {o}</button>
          ))}
        </div>
      </Section>

      <Section title="Certification">
        <label className="flex items-center gap-2 text-sm text-gray-700">
          <input type="checkbox" checked={!!value.certified} onChange={(e) => set("certified", e.target.checked || undefined)} className="h-4 w-4 accent-[#940C2C]" data-testid="filter-certified" />
          CS Certified only
        </label>
      </Section>
    </div>
  );
};

const Section = ({ title, children }) => (
  <div>
    <h4 className="text-xs font-bold text-gray-500 uppercase tracking-wider mb-2">{title}</h4>
    {children}
  </div>
);
